import { InStockIcon } from '@app/_icons/InStockIcon';

import { cn } from '@/lib/utils';

type Props = {
    className?: string;
};

export default function StockStatusIcon({ className }: Props) {
    return <InStockIcon className={cn('shrink-0 text-[#32D200]', className)} />;
}
